<app-main-nav-bar></app-main-nav-bar>
<div class="page-wrapper bg-red p-t-180 p-b-100 font-robo">
  <div class="wrapper wrapper--w960">
    <div class="card card-2">
      <div class="card-body">
        <div class="main" data-request="1335">
          <div class="wrap">
            <div class="offer elem" style="display: block;">
              <div class="row">
                <div class="col col-12">
                  <div class="head">
                    <h2>طرح های پیشنهادی</h2>
                    <p>لطفا یکی از طرح های پیشنهادی را انتخاب کنید</p>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col col-12">
                  <div class="offers">
                    <app-radio-button [Group]="formGroup" (OnChange)="setOfferDurationList()" [fieldName]="'duration'" [list]="durations" [translation]="translation"></app-radio-button>
                    <div *ngFor="let offer of offerDuration" class="item">
                      <div class="card" style="text-align: right">
                        <div class="touch"><label class="checkbox">
                          <input (change)="onSelectionChange(offer)"
                                 name="health-offer" type="radio" value="1" class="input input-health-offer">
                          <span>{{offer["offerName"]}}</span></label>
                          <div class="info" id="{{offer.id}}">
                            <div class="row">
                              <div class="col col-7"><span>شرکت بیمه</span></div>
                              <div class="col col-5"><span dir="ltr">{{offer.companyName}}</span>
                              </div>
                            </div>
                            <div *ngFor="let item of offer.services" class="row">
                              <div class="col col-7"><span>{{appSettingsService.translateEnglish(item.getPersianLabel(), translation)}}</span></div>
                              <div class="col col-5 "><div class="mark"><span dir="ltr">{{item.getValue()}}</span></div>
                                <span>تومان</span>
                              </div>
                            </div>
                            <div *ngIf="offer.discountsList && offer.discountsList.length">
                              <div *ngFor="let item of offer.discountsList" class="row">
                                <div class="discounts">
                                  <span>{{item}}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="payment">
                            <div class="row">
                              <div class="col col-6 price-label">
                                <span>مبلغ قابل پرداخت(حق بیمه {{appSettingsService.translateEnglish(durationFormControl.value, translation)}})</span>
                              </div>
                              <div class="col col-6">
                                <div class="amount amount-discount"
                                     *ngIf="offer.costs[durationFormControl.value].price !== offer.costs[durationFormControl.value].originalPrice">
                                  <span class="mark old-price"
                                        dir="ltr">{{getCurrency(offer.costs[durationFormControl.value].originalPrice)}}</span>
                                  <span>تومان</span>
                                </div>
                                <div
                                  [ngClass]="offer.costs[durationFormControl.value].originalPrice !== offer.costs[durationFormControl.value].price ? 'amount' : ''">
                                  <span class="mark" dir="ltr">{{getCurrency(offer.costs[durationFormControl.value].price)}}</span>
                                  <span>تومان</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <app-custom-button
                [BackButton]="true"
                [disabled]="!formGroup.valid"
                [LabelText]="'ادامه'"
                [Show]="true"
                (OnClick)="submit()"
                [backUrl]="'/individual-accidents/basic-information'"
              ></app-custom-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
